import React, {
  useCallback, useRef,
} from 'react';

import { BlockHeader } from 'components/blocks/BlockHeader';
import { BoxWithShadow } from 'components/blocks/BoxWithShadow';
import { useTwFidgetFactory } from 'twitter/utils';
import { SubscriberDataEvent, useAnalytics } from 'util/analytics';
import { useReadyOnWebOnly } from 'util/useReadyOnWebOnly';
import { Timeline } from 'twitter/widgets';

/**
 * @see https://github.com/andrewsuzuki/react-twitter-widgets/issues/45
 */
export const Twitter = ({ feed }: { feed: string }) => {
  const a = useAnalytics();
  const div = useRef<HTMLDivElement>(null);
  const ready = useReadyOnWebOnly();

  const onTwitterClick = useCallback(() => {
    a.subcriberEvent(SubscriberDataEvent.HomePageClick, { url: `https://twitter.com/${feed}` });
  }, [a, feed]);

  const twWidgets = useTwFidgetFactory();

  if (!ready || !twWidgets) {
    return null;
  }

  return (
    <BoxWithShadow>
      <BlockHeader title="">
        <a href={`https://twitter.com/${feed}`} onClick={onTwitterClick}>
          @
          {feed}
        </a>
      </BlockHeader>
      {/* eslint-disable-next-line jsx-a11y/no-static-element-interactions */}
      <div className="p-3 pb-0 overflow-hidden" onClick={onTwitterClick} ref={div}>
        <Timeline
          dataSource={{
            sourceType: 'profile',
            screenName: feed,
          }}
          options={{
            height: '400',
            noheader: true,
            nofooter: true,
            noborders: true,
            borderColor: '#FFFFFF',
            'tweet-limit': 1,
            tweetLimit: 1,
            id: `profile:${feed}`,
            chrome: 'noheader nofooter noborders transparent noscrollbar',
          }}
        />
      </div>
    </BoxWithShadow>
  );
};
